<template>
    <van-popup class="report-act-popup-box" position="bottom" v-bind:value="showReportActPopup && showPopup" v-bind:close-on-click-overlay="false">
        <div class="report-act-popup-close" @click="clickClose"><span class="close"></span></div>
        <!-- <div class="report-act-popup" :class="'act-popup-'+curReportActPopupType" :style="'background-image:url('+(curReportActPopupType == 1 && reportActProductGiftData.bg && reportActProductGiftData.bg != '' ? reportActProductGiftData.bg : curReportActPopupType == 2 && reportActProductDiffData.bg && reportActProductDiffData.bg != '' ? reportActProductDiffData.bg : curReportActPopupType == 3 && reportActProductVipYearData.bg && reportActProductVipYearData.bg != '' ? reportActProductVipYearData.bg : (curReportActPopupType == 4 || curReportActPopupType == 5) && reportActProductVipFullData.bg && reportActProductVipFullData.bg != '' ? reportActProductVipFullData.bg : '')+')'"> -->
        <div class="report-act-popup" :class="'act-popup-'+(showFreeCharacter && curReportActPopupType == 1 ? curReportActPopupType+'1' : curReportActPopupType)" :style="curReportActPopupType == 1 && reportActProductGiftData.bg && reportActProductGiftData.bg != '' ? (showFreeCharacter && reportActProductGiftData.free_bg && reportActProductGiftData.free_bg != '' ? 'background-image:url('+reportActProductGiftData.free_bg+')' : 'background-image:url('+reportActProductGiftData.bg+')') : curReportActPopupType == 2 && reportActProductDiffData.bg && reportActProductDiffData.bg != '' ? 'background-image:url('+reportActProductDiffData.bg+')' : curReportActPopupType == 3 && reportActProductVipYearData.bg && reportActProductVipYearData.bg != '' ? 'background-image:url('+reportActProductVipYearData.bg+')' : (curReportActPopupType == 4 || curReportActPopupType == 5) && reportActProductVipFullData.bg && reportActProductVipFullData.bg != '' ? 'background-image:url('+reportActProductVipFullData.bg+')' : ''">
            <div class="report-act-pp-tab" v-if="curReportActPopupType == 3 || curReportActPopupType == 4">
                <div class="report-act-tab-1" @click="toggleTab(3)"></div>
                <div class="report-act-tab-2" @click="toggleTab(4)"></div>
            </div>
            <div class="report-act-pp-content">
                <p v-if="curReportActPopupType == 2">原差价{{ reportActProductDiffData.rate_price }}元，现仅需补<span class="green">{{ reportActProductDiffData.price }}元</span>解锁</p>
                <p v-if="curReportActPopupType == 3">只需要补充<span class="green">{{ reportActProductVipYearData.rate_price+'-'+reportActProductVipYearData.diff_price+'='+reportActProductVipYearData.price }}</span>元即可享受以下会员特权</p>
                <p v-if="curReportActPopupType == 4 || curReportActPopupType == 5">只需要补充<span class="green">{{ reportActProductVipFullData.rate_price+'-'+reportActProductVipFullData.diff_price+'='+reportActProductVipFullData.price }}</span>元即可享受以下会员特权</p>
            </div>
            <div class="report-act-pp-btn-box">
                <button v-if="curReportActPopupType == 1" class="report-act-pp-btn" @click="clickReportActButton"><i class="iconfont icon-key"></i>{{reportActCountSecond == 0 ? '限时已到，马上享受不错过' : '限时骨折'+(reportActProductGiftData ? reportActProductGiftData.price : '?')+(showFreeCharacter ? '元解锁天赋能力' : '元解锁两项分析')}}</button>
                <button v-if="curReportActPopupType == 2" class="report-act-pp-btn" @click="clickReportActButton"><i class="iconfont icon-key"></i>{{reportActCountSecond == 0 ? '限时已到，马上享受不错过' : '限时补'+(reportActProductDiffData ? reportActProductDiffData.price : '?')+'元差价即可解锁全部内容'}}</button>
                <button v-if="curReportActPopupType == 3" class="report-act-pp-btn" @click="clickReportActButton"><i class="iconfont icon-key"></i>{{reportActCountSecond == 0 ? '限时已到，抓住机会的尾巴' : '马上补'+(reportActProductVipYearData ? reportActProductVipYearData.price : '?')+'元差价开通年会员'}}</button>
                <button v-if="curReportActPopupType == 4 || curReportActPopupType == 5" class="report-act-pp-btn" @click="clickReportActButton"><i class="iconfont icon-key"></i>{{reportActCountSecond == 0 ? '限时已到，抓住机会的尾巴' : '马上补'+(reportActProductVipFullData ? reportActProductVipFullData.price : '?')+'元差价开通终身会员'}}</button>
                <div  v-if="curReportActPopupType == 1 && reportActCountSecond > 0" class="report-act-pp-btn-text">{{reportActCountTime2}}后恢复原价{{ reportActProductGiftData ? reportActProductGiftData.rate_price : '?' }}元</div>
                <div  v-if="curReportActPopupType == 2 && reportActCountSecond > 0" class="report-act-pp-btn-text">{{reportActCountTime2}}后恢复原价{{ reportActProductDiffData ? reportActProductDiffData.rate_price : '?' }}元</div>
                <div  v-if="curReportActPopupType == 3 && reportActCountSecond > 0" class="report-act-pp-btn-text">{{reportActCountTime2}}后恢复原价{{ reportActProductVipYearData ? reportActProductVipYearData.rate_price : '?' }}元</div>
                <div  v-if="(curReportActPopupType == 4 || curReportActPopupType == 5) && reportActCountSecond > 0" class="report-act-pp-btn-text">{{reportActCountTime2}}后恢复原价{{ reportActProductVipFullData ? reportActProductVipFullData.rate_price : '?' }}元</div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { CONFIG } from '../../modules/config'
import { MIX } from '../../modules/utils';
export default {
    name: 'ReportActPopup',
    computed: {
        showReportActPopup() {
            return this.$store.state.report.showReportActPopup;
        },
        curReportActPopupData() {
            return this.$store.state.report.curReportActPopupData;
        },
        curReportActPopupType: {
            get() {
                return this.$store.state.report.curReportActPopupType;
            },
            set(value) {
                this.$store.state.report.curReportActPopupType = value;
            }
        },
        showFreeCharacter() {
            return this.$store.state.report.showFreeCharacter;
        },
        reportActProductGiftData() {
            return this.$store.state.report.reportActProductGiftData;
        },
        reportActProductDiffData() {
            return this.$store.state.report.reportActProductDiffData;
        },
        reportActProductVipYearData() {
            return this.$store.state.report.reportActProductVipYearData;
        },
        reportActProductVipFullData() {
            return this.$store.state.report.reportActProductVipFullData;
        },
        reportActCountSecond() {
            return this.$store.state.report.reportActCountSecond;
        },
        reportActCountTime2() {
            return this.$store.state.report.reportActCountTime2;
        }
    },
    data() {
        return {
            showPopup: true
        }
    },
    mounted() {
        let path = this.$router.history.current.fullPath;
        if(path.indexOf('diagram') != -1 || path.indexOf('strong') != -1) {
            this.showPopup = false
        }
    },
    methods: {
        toggleTab(tab) {
            console.log('toggleTab-----', tab, this.reportActProductVipYearData, this.reportActProductVipFullData)
            this.curReportActPopupType = tab;
        },
        clickClose() {
            this.$store.state.report.showReportActPopup = false;
            if(this.curReportActPopupType == 1 || this.curReportActPopupType == 2) {
                var curParams = this.$router.history.current.params;
                console.log('ReportActPopup---clickBack------', curParams, this.curReportActPopupData)
                // 处理页面跳转
                if(curParams.from && curParams.from != '') {
                    if(curParams.from == 'collate') { return; }
                    if(curParams.from == 'share') {
                        this.$router.back();                    
                    }else if(curParams.from == 'discusslist') {
                        let detailInfo = this.$store.state.detail.personInfo;
                        if(detailInfo && detailInfo.id) {
                            this.$router.replace('/discuss/discusslist/'+detailInfo.id);
                        }
                    }else if(curParams.from == 'discussmain') {
                        let lunpanData = this.$store.state.discuss.lunpanData;
                        if(lunpanData && lunpanData.id) {
                            this.$router.replace('/discuss/discussmain/'+lunpanData.id);
                        }
                    }else if(curParams.from.indexOf('discussshare') >= 0) {
                        let tempArr = curParams.from.split('-'),
                            fromPage = tempArr[1], shareCode = tempArr[2];
                        console.log('discussshare----', fromPage, shareCode);
                        this.$router.replace('/share/discuss/'+fromPage+'/'+shareCode);
                    // }else if(curParams.from == 'collate') {
                    //     this.$router.replace('/collate');
                    }else {
                        this.$router.replace('/detail/'+curParams.from+'/'+curParams.id);
                    }
                }else {
                    this.$router.replace('/collate');
                    this.$store.state.report.showReportActPopup = false;
                }
                this.$store.dispatch('report/resetReportData');
            }
            if(this.reportActCountSecond == 0 && this.curReportActPopupData) {
                this.$store.state.report.curReportActPopupData = null;
                this.$store.dispatch('report/checkReportActData');
            }else {
                // 显示悬浮按钮、开始跑倒计时
                this.$store.state.report.showReportActBtn = true;
                this.$store.state.report.showReportActPopup = false;
                this.$store.dispatch('report/runReportAICount');
            }
        },
        clickReportActButton() {
            let me = this;
            let showReportPage = this.$store.state.report.showReportPage,
                reportData = this.$store.state.report.curReportActPopupData, 
                productData = {};
            if(this.curReportActPopupType == 1) {
                MIX.trackButtonClicked('only_one_character_talent_bt');
            }else if(this.curReportActPopupType == 2) {
                MIX.trackButtonClicked('only_one_unlock_all_bt');
            }
            if(this.curReportActPopupType == 1 || this.curReportActPopupType == 2) {
                productData = this.curReportActPopupType == 1 ? Object.assign(this.reportActProductGiftData) : this.curReportActPopupType == 2 ? Object.assign(this.reportActProductDiffData) : null;
                if(showReportPage) {
                    this.clickPayReport(productData);
                }else {
                    this.$store.dispatch('report/getReportDetailInfo', {
                        hid: reportData.hid,
                        cb: function(dData) {
                            me.$store.state.detail.personInfo = dData;
                            me.$store.state.report.fromPage = 'collate';
                            me.$store.dispatch('report/initReportAIConfig', {
                                cb: function() {
                                    me.$store.dispatch('report/getReportInfo', {
                                        detailInfo: dData,
                                        cb: function() {
                                            me.$router.replace('/report/collate/'+dData.id);
                                        }
                                    })
                                }
                            });
                        }
                    })
                }
            }else {
                productData = this.curReportActPopupType == 3 ? Object.assign(this.reportActProductVipYearData) : this.curReportActPopupType == 4 || this.curReportActPopupType == 5 ? Object.assign(this.reportActProductVipFullData) : null;
                this.clickPayVip(productData);
            }
        },
        /**
         * 测算支付
         * @param {*} productData 
         */
        clickPayReport(productData) {
            let reportData = this.$store.state.report.curReportActPopupData;
            let payType = CONFIG.platform == 'qq' ? 'wx_qr' : 'wx_pub';
            console.log('clickPayReport------', payType, reportData, productData);
            if(reportData == null || productData == null) {
                this.$toast('商品出错，请刷新稍后再试')
                return;
            }
            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: productData.pid,              //支付项目id
                    ptype: payType,                    //支付方式
                    ext: reportData.hid                //支付的评测id
                },
                mixParams: {
                    pid: productData.pid,
                    product_name: productData.title,
                    price: productData.price,
                    from: this.curReportActPopupType == 1 ? 'price_only_one_chance' : 'price_limited_time',
                },
                sucCb: () => {
                    console.log('支付成功，更新测评报告数据');
                    this.$store.dispatch('report/updateReportShowTimeAndActData');
                    // 更新测验报告数据
                    if(reportData) {
                        this.$store.dispatch('report/updateReportInfo', reportData.hid);
                    }
                    // 更新ai状态
                    this.$store.state.detail.personInfo.ai = 1;
                    this.$store.dispatch('record/updateRecordListAIStatus', {
                        id: reportData.hid
                    });
                },
                failCb: () => {
                    console.error("支付失败");
                }
            });
        },
        /**
         * vip支付
         * @param {*} productData 
         */
        clickPayVip(productData){
            let reportData = this.$store.state.report.curReportActPopupData;
            let payType = CONFIG.platform == 'qq' ? 'wx_qr' : 'wx_pub';
            console.log('clickPayVip------', payType, reportData, productData);
            if(reportData == null || productData == null) {
                this.$toast('商品出错，请刷新稍后再试')
                return;
            }
            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: productData.pid,              //支付项目id
                    ptype: payType,                    //支付方式
                    discount: CONFIG.vip_discount      //支付vip
                },
                mixParams: {
                    pid: productData.pid,
                    product_name: productData.title,
                    price: productData.price,
                    from: 'price_upgrade_vip',
                },
                sucCb: () => {
                    let userData = Object.assign({}, this.$store.state.userData);
                    this.$store.dispatch('report/updateReportShowTimeAndActData');
                    console.log('支付成功，更新测评报告数据', userData);
                    if(!userData || !userData.uid) {
                        return;
                    }
                    // 更新vip信息;
                    this.$store.dispatch('user/getUserInfo', {
                        id: userData.uid,
                        cb: (data) => {
                            console.log('更新用户vip状态', data);
                            this.$set(this.$store.state.userData, 'vip', data.vip);
                            this.$set(this.$store.state.userData.info, 'vip', data.vip);
                            this.$bus.emit('updateMyVipInfo');
                        }
                    });
                },
                failCb: () => {
                    console.error("支付失败");
                }
            });
        }
    }
}
</script>
